<template>
    <div class="content">
        <div class="content-div shu">
            <span>输入在活动名称中以排除他们</span>
            <el-input
                type="textarea"
                :rows="10"
                placeholder="输入广告活动，用换行区分每个广告活动"
                style="margin: 8px 0 20px;font-size: 12px;"
                v-model="textarea">
            </el-input>
            <el-button type="primary" size="mini" style="float: right;" @click="add()">添加广告活动</el-button>
        </div>
        <div class="content-div">
            <div class="content-buttom">
                <span>{{arr.length}} 已添加的广告活动</span>
                <span class="content-buttom-txet" @click="onDeleteAll">全部移除</span>
            </div>
            <div class="content-data">
                <div class="content-list" v-for="(item, i) in arr" :key="i">
                    <span>{{item}}</span>
                    <span class="cha" @click="onDelete(i)">x</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { str_arr } from "@/utils/method";
export default {
    data() {
        return {
            textarea: "",
            arr: []
        };
    },
    methods: {
        add() {
            let arr = str_arr(this.textarea);
            this.arr = [...new Set(this.arr.concat(arr))];
            this.textarea = "";
            this.$emit("on-exclude", this.arr);
        },
        onDeleteAll() {
            this.arr = [];
            this.$emit("on-exclude", this.arr);
        },
        onDelete(i) {
            this.arr.splice(i, 1);
            this.$emit("on-exclude", this.arr);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;
    .shu {
        border-right: 1px solid #cecfd1;
    }
    .content-div {
        width: 50%;
        padding: 25px 20px;
    }
    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }
    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;
        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;
            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }
    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
</style>
